import create from 'zustand';

import { IAppState } from './types';

const useAppState = create<IAppState>()((set) => ({
  file: null,
  imageIndex: 0,
  imageHistory: [],
  uploadError: null,
  isUploading: false,
  isProcessing: false,
  isDownloaded: false,
  imageName: undefined,
  isOpen: false,
  isCroped: true,
  option: '',
  crop: null,
  imageProperties: { offsetHeight: 0, offsetWidth: 0 },
  validWidth: false,
  validHeight: false,

  addImage: (file, blobUrl) =>
    set((state) => ({
      ...state,
      file,
      imageName: file.name,
      isUploading: true,
      displayUploadSuccess: true,
      option: 'format_1_1',
      imageIndex: 0,
      imageHistory: [blobUrl],
    })),

  deleteImage: () =>
    set(() => ({
      file: null,
      imageIndex: 0,
      imageHistory: [],
      uploadError: null,
      isUploading: false,
      isProcessing: false,
      isDownloaded: false,
      imageName: undefined,
      isOpen: false,
      crop: null,
      isCroped: true,
      option: 'format_custom',
      imageProperties: {
        offsetWidth: 0,
        offsetHeight: 0,
      },
      validWidth: false,
      validHeight: false,
    })),

  setUploadError: (uploadError) =>
    set((state) => ({
      ...state,
      uploadError,
      isUploading: false,
    })),

  setIsUploading: (isUploading) =>
    set((state) => ({
      ...state,
      isUploading,
    })),
  setIsProcessing: (isProcessing) =>
    set((state) => ({
      ...state,
      isProcessing,
    })),
  setIsDownloaded: (isDownloaded) =>
    set((state) => ({
      ...state,
      isDownloaded,
    })),
  setIsOpen: (isOpen) =>
    set((state) => ({
      ...state,
      isOpen,
    })),
  setIsCroped: (isCroped) =>
    set((state) => ({
      ...state,
      isCroped,
    })),
  setOption: (option) =>
    set((state) => ({
      ...state,
      option,
    })),

  setCrop: (crop) =>
    set((state) => ({
      ...state,
      crop,
    })),
  setImageProperties: (imageProperties) =>
    set((state) => ({
      ...state,
      imageProperties,
    })),
  setImageIndex: (imageIndex) =>
    set((state) => ({
      ...state,
      imageIndex,
    })),
  setImageHistory: (imageHistory) =>
    set((state) => ({
      ...state,
      imageHistory,
    })),
  setNewState: (initialState) =>
    set((state) => ({
      ...state,
      imageHistory: [...state.imageHistory, initialState],
      imageIndex: state.imageIndex + 1,
    })),
  setValidWidth: (validWidth) =>
    set((state) => ({
      ...state,
      validWidth,
    })),
  setValidHeight: (validHeight) =>
    set((state) => ({
      ...state,
      validHeight,
    })),
}));

export default useAppState;
